var _defs, _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStripe = function SvgStripe(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "usuario",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.57 18.57",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;fill-rule:evenodd;}.cls-2{fill:#a9a9a9;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1234",
    className: "cls-2",
    x: 0.13,
    y: 0.13,
    width: 18.32,
    height: 18.32,
    rx: 4,
    ry: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5473",
    className: "cls-1",
    d: "m8.44,7.1c0-.44.36-.63.94-.63.97.02,1.92.27,2.77.72v-2.59c-.88-.35-1.82-.52-2.77-.51-2.26,0-3.77,1.18-3.77,3.17,0,3.08,4.24,2.58,4.24,3.91,0,.51-.45.68-1.07.68-1.08-.06-2.14-.37-3.08-.91v2.66c.96.42,2,.63,3.05.63,2.32,0,3.91-1.14,3.91-3.17.02-3.31-4.23-2.71-4.23-3.96h0Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStripe);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "stripe.aa4187c4cb191c9a36c2e5925060a281.svg";